import { TableDataFetch } from "components/common";
import { PayrollClient } from "services";
import React, { useMemo } from "react";

export const PayrollTableDataFetch = (props) => {
  const client = useMemo(() => PayrollClient(), []);

  return <TableDataFetch client={client} {...props} />;
};

export default PayrollTableDataFetch;
